import React from 'react';
import { RoleChangeCallout } from 'src/components/ContactFormComponents/ChangeUserRoleDialogue/utils/deriveRoleChangeCallouts';
import './role-change-callouts.scss';

export interface RoleChangeCalloutsProps {
  callouts: RoleChangeCallout[];
}

const RoleChangeCallouts = ({ callouts }: RoleChangeCalloutsProps) => {
  if (callouts.length === 0) {
    return null;
  }

  return (
    <ul className="role-change-callouts">
      {callouts.map((callout: RoleChangeCallout, index: number) => (
        <li
          key={index}
          className={
            callout.tone === 'warning'
              ? 'role-change-callouts-item role-change-callouts-item-warning'
              : 'role-change-callouts-item role-change-callouts-item-info'
          }
        >
          {callout.message}
        </li>
      ))}
    </ul>
  );
};

export default RoleChangeCallouts;
